import { render, staticRenderFns } from "./LogoAcademy.vue?vue&type=template&id=4f706eef&"
import script from "./LogoAcademy.vue?vue&type=script&lang=js&"
export * from "./LogoAcademy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports